import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';

import { NimaLoadingSurface } from '@Common/nimaLoading';
import { styles } from './style';
import * as actions from './action';
import * as util from '@Util/';
import messages from '@Locales/config/common/messages';

/*
 * Interstitial de login por token. Equivale ao /confirmar-acesso da NIMA:
 * espera de tela cheia com o simbolo oficial, sem mais nada na tela.
 */
class AutoLogin extends Component {
  render() {
    const { intl } = this.props;
    return (
      <NimaLoadingSurface
        size="lg"
        page
        label={intl.formatMessage(messages.loadingConfig)}
      />
    );
  }

  componentWillMount() {
    util.deleteCookie('auth', '', '');
  }

  componentDidMount() {
    const { setSignIn, match } = this.props;
    const { token } = match.params;
    setSignIn(token);
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setSignIn: actions.autoLogin
    },
    dispatch
  );

AutoLogin = withStyles(styles)(AutoLogin);
AutoLogin = injectIntl(AutoLogin);
AutoLogin = connect(null, mapDispatchToProps)(AutoLogin);

export default AutoLogin;
